import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { GmailWebhookPayload, WebhookSuccessResponse } from "../models/webhook";

/**
 * Webhook endpoint group
 *
 * This group handles incoming webhooks from various external services.
 * Webhooks are unauthenticated endpoints (no Authorization middleware)
 * and rely on service-specific verification mechanisms (e.g., signature validation).
 *
 * Design principles:
 * - Each webhook type gets its own endpoint
 * - All endpoints return WebhookSuccessResponse for successful processing
 * - Endpoints should catch and log errors but return 200 OK to prevent retries
 * - Service-specific verification happens in the handler layer
 */
export const WebhookGroup = HttpApiGroup.make("webhook")
  .add(
    HttpApiEndpoint.post("gmail", "/webhooks/gmail")
      // No Authorization middleware - webhook is verified via Pub/Sub signature
      .setPayload(GmailWebhookPayload)
      .addSuccess(WebhookSuccessResponse)
      .addError(HttpApiError.BadRequest),
  )
  .prefix("/api");
